var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.153 7.78l-.004.005-.015.017-.004.005a6.61 6.61 0 01-.014.018l-.003.003L.1 7.85a.593.593 0 00-.097.27v.003L0 8.15v.06l.002.025v.004a.593.593 0 00.112.291l.002.004a.24.24 0 00.015.018l.004.005.014.016.005.006c.006.007.013.015.02.02l6.117 6.12a.596.596 0 00.842-.842L2.032 8.775h13.372a.595.595 0 100-1.19H2.032l5.101-5.102a.595.595 0 10-.842-.842L.173 7.76l-.02.021z",
  fill: "#000"
})));
export default SvgArrowLeft;